module.exports = __webpack_public_path__ + "static/img/reception.23240b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/reception.png
// module id = 0UOs
// module chunks = 1